"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeNumbersInString = void 0;
function normalizeNumbersInString(string) {
    return string.replace(/(^|[,;+-/*\s])(\.\d+)/g, '$10$2');
}
exports.normalizeNumbersInString = normalizeNumbersInString;
